// src/pages/mySettings/adminFund/index.js
import '../../../App.css'
import { useState, useEffect } from 'react';
import { Input, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { adminDepositFundAsync } from '../../../redux/slice/adminFund/adminFundSlice';
import { getUserBalanceAsync } from '../../../redux/slice/user/userSlice';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';

function AdminFund() {
    const dispatch = useDispatch();

    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const { userBalance, loading: balanceLoading } = useSelector((state) => state.userbal);
    const { loading: depositLoading } = useSelector((state) => state.adminFund);

    const [formData, setFormData] = useState({
        amount: "",
        password: "",
        remarks: "",
    });
    const [button, setButton] = useState(false);

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(getUserBalanceAsync());
        }
    }, [dispatch, isAuthenticated]);

    const handleSetFormData = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formData.amount || !formData.password || !formData.remarks) {
            message.error('Please fill in all fields');
            return;
        }

        // if (formData.password !== userdata.password) {
        //     NotificationManager.error('Your Password Not Matched With System.', '', 3000);
        //     return;
        // }

        try {
            setButton(true);

            const payload = {
                user_id: userdata.id,
                password: formData.password,
                amount: formData.amount,
                remarks: formData.remarks,
            };

            const result = await dispatch(adminDepositFundAsync(payload)).unwrap();

            dispatch(getUserBalanceAsync());

            NotificationManager.success(result.message || 'Fund deposited successfully', '', 1000);

            setFormData({
                amount: "",
                password: "",
                remarks: "",
            });
        } catch (err) {
            NotificationManager.error(err.message || 'Failed to deposit fund', '', 10000);
        } finally {
            setButton(false);
        }
    };

    return (
        <>
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 relative mt-[20px] lg:mt-[15px] px-[15px] lg:px-[30px]'>
                    <div className='col-span-12 lg:mx-auto'>
                        <div className='lg:block w-full lg:w-[40vw]'>
                            <div className='grid grid-cols-12'>
                                <div className='col-span-12 px-[6px] py-[5px] font-bold text-[0.875rem] rounded-[1px] h-[35px] bg-[linear-gradient(#022c43,_#18b0c8)] text-[#ffffff] flex flex-shrink-0 items-center justify-between'>
                                    <h5 className='text-[0.938rem] font-bold mb-0 leading-normal'>Admin Fund</h5>
                                </div>
                                <div className='col-span-12 !bg-[#ffffff] !text-[#23282c] relative flex-auto p-4'>
                                    <div className='grid grid-cols-12 lg:gap-x-6'>
                                        <div className='col-span-12 lg:col-span-6'>
                                            <div className='mb-4 !text-[#23282c]'>
                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' htmlFor="current-balance">Current Balance</label>
                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                    <Input
                                                        id='current-balance'
                                                        name='current-balance'
                                                        required
                                                        readOnly
                                                        className='antd-password'
                                                        value={userBalance?.balance ? Number(userBalance.balance).toFixed(2) : '0.00'}
                                                        loading={balanceLoading}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6'>
                                            <div className='mb-4 !text-[#23282c]'>
                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' htmlFor="amount">Deposit Fund</label>
                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                    <Input
                                                        type='number'
                                                        id='amount'
                                                        name='amount'
                                                        value={formData.amount}
                                                        required
                                                        className='antd-password'
                                                        placeholder="Enter Deposit.."
                                                        onChange={handleSetFormData}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6'>
                                            <div className='mb-4 !text-[#23282c]'>
                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' htmlFor="remarks">Remarks</label>
                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                    <Input
                                                        id='remarks'
                                                        value={formData.remarks}
                                                        name='remarks'
                                                        required
                                                        className='antd-password'
                                                        placeholder="Enter Remark.."
                                                        onChange={handleSetFormData}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6'>
                                            <div className='mb-4 !text-[#23282c]'>
                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' htmlFor="total-balance">Total Balance</label>
                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                    <Input
                                                        id='total-balance'
                                                        name='total-balance'
                                                        required
                                                        className='antd-password'
                                                        readOnly
                                                        value={userBalance?.balance ? Number(userBalance.balance).toFixed(2) : '0.00'}
                                                        loading={balanceLoading}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6'>
                                            <div className='mb-4 !text-[#23282c]'>
                                                <label className='inline-block mb-[.5rem] !text-[#23282c]' htmlFor="password">Password</label>
                                                <div className='relative flex flex-wrap items-stretch w-full text-[#23282c]'>
                                                    <Input.Password
                                                        id='password'
                                                        name='password'
                                                        value={formData.password}
                                                        required
                                                        className='antd-password'
                                                        placeholder="Enter Password.."
                                                        onChange={handleSetFormData}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6 flex items-center'>
                                            <button
                                                type='button'
                                                disabled={button || depositLoading}
                                                className='w-full !text-[#fff] !bg-[linear-gradient(-180deg,_#6fe3f5,_#065265)] text-[.875rem] rounded-[.25rem] px-[10px] mt-[10px] py-[5px]'
                                                onClick={handleSubmit}
                                            >
                                                {depositLoading ? 'Processing...' : 'Submit'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminFund;